import { render, staticRenderFns } from "./CommonTest.vue?vue&type=template&id=2c81b19e&scoped=true"
import script from "./CommonTest.vue?vue&type=script&lang=js"
export * from "./CommonTest.vue?vue&type=script&lang=js"
import style0 from "./CommonTest.vue?vue&type=style&index=0&id=2c81b19e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c81b19e",
  null
  
)

export default component.exports